import { render, staticRenderFns } from "./pendingShopLook.vue?vue&type=template&id=020006d8&scoped=true"
import script from "./pendingShopLook.vue?vue&type=script&lang=js"
export * from "./pendingShopLook.vue?vue&type=script&lang=js"
import style0 from "./pendingShopLook.vue?vue&type=style&index=0&id=020006d8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020006d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('020006d8')) {
      api.createRecord('020006d8', component.options)
    } else {
      api.reload('020006d8', component.options)
    }
    module.hot.accept("./pendingShopLook.vue?vue&type=template&id=020006d8&scoped=true", function () {
      api.rerender('020006d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shopManagement/pendingShop/pendingShopLook.vue"
export default component.exports